import axioxBackEnd from "../config/axios/axios-back-end";

export const getAllApplications = async () => {
  const response = await axioxBackEnd.get("/api/applications");
  return response.data;
};

export const createFAQ = async (data) => {
  const id  = data._id;
  delete data._id;
  const response = await axioxBackEnd.post(`/api/applications/${id}/faq`, data);
  return response.data;
}

export const getFAQList = async (id) => {
  const response = await axioxBackEnd.get(`/api/applications/${id}/faq`);
  return response.data;
}

export const deleteFAQ = async (data) => {
  const response = await axioxBackEnd.delete(`/api/applications/${data.appId}/faq/${data.id}`);
  return response.data;
}

export const updateFAQ = async (data) => {
  const response = await axioxBackEnd.put(`/api/applications/${data.appid}/faq/${data.id}`,data);
  return response.data;
}

export default {
  getAllApplications,
  createFAQ,
  getFAQList,
  deleteFAQ,
  updateFAQ
};
